module.exports = __webpack_public_path__ + "a4e60f3fb7e74f3a2517e125cc680416.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/script/svganimations/svg/CLIENTS_SVG.svg
 ** module id = 7
 ** module chunks = 0
 **/